import Dashboard from '@/pages/customer/Dashboard';

const meta = { auth: true, customer: true };

const customerRoutes = [
  {
    path: '/',
    name: 'home',
    component: Dashboard,
    meta,
  },
  {
    path: '/products',
    name: 'products',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/Products'),
    meta,
  },
  {
    path: '/products/:id',
    name: 'product',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/ProductDetails'),
    meta,
  },
  {
    path: '/training',
    name: 'training',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/PreTraining'),
    meta,
  },
  {
    path: '/training/:id',
    name: 'training-lessons',
    component: () =>
      import(/* webpackChunckName: "customer" */ '../pages/customer/PretrainingLessons'),
    meta,
  },
  {
    path: '/post-training',
    name: 'post-training',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/PostTraining'),
    meta,
  },
  {
    path: '/post-training/:id',
    name: 'post-training-lessons',
    component: () =>
      import(/* webpackChunckName: "customer" */ '../pages/customer/PostTrainingLessons'),
    meta,
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/Orders'),
    meta,
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/Transactions'),
    meta,
  },
  {
    path: '/referrals',
    name: 'referrals',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/Referrals'),
    meta,
  },
  {
    path: '/schedules',
    name: 'schedules',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/Schedules'),
    meta,
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/Account'),
    meta,
  },
  {
    path: '/giftcards',
    name: 'giftcard',
    component: () => import(/* webpackChunckName: "customer" */ '../pages/customer/Giftcards'),
    meta,
  },
];

export default customerRoutes;
